import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

const formatElapsed = (startTime: dayjs.Dayjs): string => {
  const diffInSeconds = dayjs().diff(startTime, 's');
  const minutes = Math.floor(diffInSeconds / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (diffInSeconds % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};

/**
 * Returns elapsed call time as "MM:SS", updating every second.
 */
export const useCallTimer = (): string => {
  const [callTime, setCallTime] = useState('00:00');

  useEffect(() => {
    const startTime = dayjs();
    setCallTime(formatElapsed(startTime));
    const id = setInterval(() => setCallTime(formatElapsed(startTime)), 1000);
    return () => clearInterval(id);
  }, []);

  return callTime;
};
